<template>
  <div>
    <el-row>
      <el-col :span="12" :offset="6">
        <div style="font-size:20px;margin-bottom:20px">Locations</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" :offset="6">
        <el-input
          placeholder="Type to search for a location"
          size="small"
          prefix-icon="el-icon-search"
          v-model="searchText"
          style="width:300px"
        />
        <el-select v-model="filterType" size="small">
          <el-option key="o1" label="All locations" value="a"></el-option>
          <el-option key="o2" label="Companies" value="c"></el-option>
          <el-option key="o3" label="Parkings" value="p"></el-option>
        </el-select>
        <el-select v-model="filterStatus" size="small">
          <el-option key="o1" label="Any state" value="any"></el-option>
          <el-option key="o2" label="Enabled" value="e"></el-option>
          <el-option key="o3" label="Disabled" value="d"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <a v-if='$store.getters.isAdmin' href="#" @click="onAddLocation($event)" style="margin-right:10px" class=""><i class="el-icon-circle-plus-outline" style="color:#409EFF;font-size:24px"></i></a>
        <a href="#" @click="onRefresh($event)"><i class="el-icon-refresh" style="color:#409EFF;font-size:24px" /></a>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12" :offset="6">
        <el-table :data="companies" :row-class-name="rowStatus" empty-text="No records">
          <el-table-column prop="name"/>
          <el-table-column fixed="right" width="120">
            <template v-slot:default="scope">
              <el-button @click="editCompany(scope.$index)" icon="el-icon-edit-outline" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.el-table .disabled-row {
  color: salmon;
}
</style>
<script>
import axios from 'axios'

export default {
  name: "Companies",
  data() {
    return {
      companies: [],
      searchText: "",
      filterType: "a",
      filterStatus: "e",
      tf: null
    };
  },
  mounted() {
    this.refreshData();
  },
  watch: {
    searchText: function(oldText, newText) {
      this.search();
    },

    filterType: function(oldText, newText) {
      this.search();
    },

    filterStatus: function(oldText, newText) {
      this.search();
    },
  },
  computed: {},
  methods: {
    rowStatus({ row, _ }) {
      if (!row.isActive) return "disabled-row";
      return ";";
    },

    editCompany(idx) {
      let id = this.companies[idx].externalId;
      this.$router.push({ name: "Company", params: { id: id } });
    },

    onAddLocation(e) {
      e.preventDefault();
      this.$router.push({ name: "Company", params: { id: 'add' } });
    },

    onRefresh(e) {
      e.preventDefault();
      this.refreshData();
    },

    search: function() {
      if (this.tf != null) clearTimeout(this.tf);
      this.tf = setTimeout(this.refreshData, 500);
    },

    refreshData() {
      if (this.tf != null) clearTimeout(this.tf);

      let cond = [];

      if (this.filterStatus === 'e')
        cond.push('is-active=true');
      else if (this.filterStatus === 'd')
        cond.push('is-active=false');

      if (this.filterType === "c")
        cond.push('location-type=FIRMA');
      else if (this.filterType === "p")
        cond.push('location-type=PARKING');

      if (this.searchText !== "")
        cond.push(`search-text=${encodeURIComponent(this.searchText)}`);

      var url = `${process.env.VUE_APP_API}locations?${cond.join("&")}`;

      axios.get(url, {
        headers: {
          'Authorization': window.sessionStorage.getItem("token")
        }
      }).then(result => {
        this.companies = result.data;
      });
    }
  }
};
</script>
